export default `:host {
  display: block;
}
:host ids-icon {
  transition: transform var(--ids-motion-duration) var(--ids-motion-ease);
  justify-self: end;
}

:host([hidden]) {
  display: none;
}

:host([aria-expanded=true]) ids-icon[icon=caret-down] {
  transform: rotateX(180deg);
}

:host([hidden-by-filter]) {
  display: none;
}

:host([hidden-by-filter][child-filter-match]) {
  display: initial;
}

.ids-accordion-header {
  border-width: var(--ids-border-width-sm);
  border-style: solid;
  align-items: center;
  cursor: pointer;
  display: flex;
  grid-auto-flow: column;
  user-select: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ids-accordion-header ::slotted(ids-text) {
  flex-grow: 1;
}
.ids-accordion-header .ids-accordion-display-icon {
  display: none;
}
.ids-accordion-header:focus {
  outline: 0;
}
.ids-accordion-header:not([class*=color-variant-]) {
  border-color: var(--ids-color-transparent);
  border-bottom-color: var(--ids-accordion-header-color-border-bottom);
  border-inline-width: 0;
  padding: var(--ids-accordion-header-padding);
}
.ids-accordion-header:not([class*=color-variant-]):not(.disabled):focus {
  border-color: var(--ids-accordion-header-color-border-focus);
  box-shadow: var(--ids-accordion-header-shadow-focus);
  border-width: var(--ids-border-width-sm);
}
.ids-accordion-header:not([class*=color-variant-]).disabled {
  color: var(--ids-accordion-header-color-text-disabled);
}
.ids-accordion-header:not([class*=color-variant-]).disabled ids-icon {
  color: var(--ids-accordion-header-color-border-disabled);
}
.ids-accordion-header:not([class*=color-variant-]).disabled {
  cursor: unset;
  border-bottom-color: transparent;
}
.ids-accordion-header:not([class*=color-variant-])[class*=depth-]:not(.depth-1) {
  padding-inline-start: 16px;
}
@media (max-width: 927px) {
  .ids-accordion-header:not([class*=color-variant-])[class*=depth-]:not(.depth-1) {
    width: fit-content;
  }
}
.ids-accordion-header:not([class*=color-variant-]).borderless.expanded:not([class*=depth-]), .ids-accordion-header:not([class*=color-variant-]).borderless.expanded.depth-1 {
  border-bottom-color: transparent;
}
.ids-accordion-header:not([class*=color-variant-]).borderless[class*=depth-]:not(.depth-1):not(:focus) {
  border-color: transparent;
}
.ids-accordion-header.selected {
  font-weight: bolder;
}
.ids-accordion-header.header-fill {
  background-color: var(--ids-accordion-header-gray-bg-color);
}
.ids-accordion-header.header-fill:hover {
  background-color: var(--ids-app-menu-header-color-background-hover);
}
.ids-accordion-header.has-icon .ids-accordion-display-icon {
  display: flex;
}
.ids-accordion-header.color-variant-app-menu {
  margin-inline: 8px;
  border-radius: 4px;
  background-color: var(--ids-drawer-app-menu-color-background);
  border-color: var(--ids-drawer-app-menu-color-border);
}
.ids-accordion-header.color-variant-app-menu.expanded {
  background-color: var(--ids-color-transparent);
  border-color: var(--ids-color-transparent);
}
.ids-accordion-header.color-variant-app-menu {
  color: var(--ids-app-menu-accordion-header-color-text-default);
}
.ids-accordion-header.color-variant-app-menu:hover {
  background-color: var(--ids-app-menu-header-color-background-hover);
  border-color: var(--ids-app-menu-header-color-border-hover);
}
.ids-accordion-header.color-variant-app-menu:focus {
  color: var(--ids-app-menu-accordion-header-color-text-focus);
  border-color: var(--ids-app-menu-accordion-header-color-border-focus);
  background-color: var(--ids-app-menu-accordion-header-color-background-focus);
}
.ids-accordion-header.color-variant-app-menu.selected {
  color: var(--ids-app-menu-accordion-header-color-text-selected);
  background-color: var(--ids-app-menu-accordion-header-selected-bg-color);
}
.ids-accordion-header.color-variant-app-menu[disabled] {
  color: var(--ids-app-menu-accordion-header-color-text-disabled);
  background-color: --ids-app-menu-accordion-header-color-background-disabled;
  border-color: var(--ids-app-menu-accordion-header-color-border-disabled);
}
.ids-accordion-header.color-variant-app-menu .filter {
  background-color: var(--ids-app-menu-accordion-header-color-background-default);
  color: var(--ids-app-menu-accordion-header-filter-color-text);
  font-weight: bold;
}
.ids-accordion-header.color-variant-app-menu.hidden-by-filter.child-filter-match {
  color: var(--ids-app-menu-accordion-header-filter-match-color-text);
}
.ids-accordion-header.color-variant-app-menu.hidden-by-filter.child-filter-match.selected {
  color: var(--ids-app-menu-accordion-header-filter-match-color-text-selected);
}
.ids-accordion-header.color-variant-app-menu {
  padding: var(--ids-accordion-header-app-menu-padding);
}
.ids-accordion-header.color-variant-sub-app-menu {
  margin-inline: 8px;
  border-radius: 4px;
  background-color: var(--ids-drawer-app-menu-color-background);
  border-color: var(--ids-drawer-app-menu-color-border);
}
.ids-accordion-header.color-variant-sub-app-menu.expanded {
  background-color: var(--ids-color-transparent);
  border-color: var(--ids-color-transparent);
}
.ids-accordion-header.color-variant-sub-app-menu {
  color: var(--ids-app-menu-accordion-header-color-text-default);
}
.ids-accordion-header.color-variant-sub-app-menu:hover {
  background-color: var(--ids-app-menu-header-color-background-hover);
  border-color: var(--ids-app-menu-header-color-border-hover);
}
.ids-accordion-header.color-variant-sub-app-menu:focus {
  color: var(--ids-app-menu-accordion-header-color-text-focus);
  border-color: var(--ids-app-menu-accordion-header-color-border-focus);
  background-color: var(--ids-app-menu-accordion-header-color-background-focus);
}
.ids-accordion-header.color-variant-sub-app-menu.selected {
  color: var(--ids-app-menu-accordion-header-color-text-selected);
  background-color: var(--ids-app-menu-accordion-header-selected-bg-color);
}
.ids-accordion-header.color-variant-sub-app-menu[disabled] {
  color: var(--ids-app-menu-accordion-header-color-text-disabled);
  background-color: --ids-app-menu-accordion-header-color-background-disabled;
  border-color: var(--ids-app-menu-accordion-header-color-border-disabled);
}
.ids-accordion-header.color-variant-sub-app-menu .filter {
  background-color: var(--ids-app-menu-accordion-header-color-background-default);
  color: var(--ids-app-menu-accordion-header-filter-color-text);
  font-weight: bold;
}
.ids-accordion-header.color-variant-sub-app-menu.hidden-by-filter.child-filter-match {
  color: var(--ids-app-menu-accordion-header-filter-match-color-text);
}
.ids-accordion-header.color-variant-sub-app-menu.hidden-by-filter.child-filter-match.selected {
  color: var(--ids-app-menu-accordion-header-filter-match-color-text-selected);
}
.ids-accordion-header.color-variant-sub-app-menu {
  margin: 0;
  padding: var(--ids-accordion-header-sub-app-menu-padding);
}
.ids-accordion-header.expander-type-plus-minus .ids-accordion-expander-icon {
  position: relative;
  margin-top: -4px;
  height: 14px;
  width: 14px;
}

::slotted(ids-icon) {
  margin-inline-end: 12px;
}

.ids-accordion-display-icon {
  margin-inline-end: 12px;
}

.ids-accordion-expander-icon:first-child {
  margin-inline-end: 8px;
}

:host {
  box-sizing: border-box;
}

.ids-module-nav-item {
  box-sizing: border-box;
  position: relative;
  transition: width var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-module-nav-item.color-variant-module-nav {
  border-color: var(--ids-color-transparent);
  border-radius: var(--ids-module-nav-common-border-radius);
  border-style: solid;
  border-width: var(--ids-border-width-sm);
  color: var(--ids-module-nav-item-text-color);
}
.ids-module-nav-item.color-variant-module-nav:hover {
  background-color: var(--ids-module-nav-item-hover-bg-color);
  color: var(--ids-module-nav-item-hover-text-color);
}
.ids-module-nav-item.color-variant-module-nav:active {
  background-color: var(--ids-module-nav-item-selected-bg-color);
  color: var(--ids-module-nav-item-selected-text-color);
  border-color: var(--ids-module-nav-item-active-border-color);
}
.ids-module-nav-item.color-variant-module-nav:focus:not(.hide-focus) {
  border-color: var(--ids-module-nav-item-active-border-color);
}
.ids-module-nav-item.color-variant-module-nav.selected {
  background-color: var(--ids-module-nav-item-selected-bg-color);
  color: var(--ids-module-nav-item-selected-text-color);
}
.ids-module-nav-item.color-variant-module-nav[disabled] {
  color: var(--ids-module-nav-item-text-color);
}
.ids-module-nav-item.color-variant-module-nav .filter {
  color: var(--ids-module-nav-item-text-color);
}
.ids-module-nav-item.color-variant-module-nav.hidden-by-filter.child-filter-match {
  color: var(--ids-module-nav-item-text-color);
}
.ids-module-nav-item.color-variant-module-nav:not([class*=display-mode-]) {
  height: var(--ids-module-nav-item-collapsed-size);
  margin-block: var(--ids-module-nav-item-collapsed-general-space-size);
  margin-inline: auto;
  overflow: hidden;
}
.ids-module-nav-item.color-variant-module-nav:not([class*=display-mode-]) .ids-accordion-display-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  opacity: 0;
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.ids-module-nav-item.color-variant-module-nav:not([class*=display-mode-]) .ids-accordion-expander-icon {
  display: none;
}
.ids-module-nav-item.color-variant-module-nav.display-mode-collapsed {
  height: var(--ids-module-nav-item-collapsed-size);
  width: var(--ids-module-nav-item-collapsed-size);
  margin: var(--ids-module-nav-item-collapsed-general-space-size) auto;
}
.ids-module-nav-item.color-variant-module-nav.display-mode-collapsed .ids-accordion-display-icon {
  margin-inline: var(--ids-module-nav-item-display-icon-collapsed-margin);
  padding: 0;
  justify-self: center;
  align-self: center;
  transition: none;
}
.ids-module-nav-item.color-variant-module-nav.display-mode-collapsed .ids-accordion-expander-icon {
  display: none;
}
.ids-module-nav-item.color-variant-module-nav.display-mode-collapsed.no-icon-collapsed {
  display: none;
}
.ids-module-nav-item.color-variant-module-nav.display-mode-collapsed ::slotted(ids-text),
.ids-module-nav-item.color-variant-module-nav.display-mode-collapsed .ids-text {
  position: absolute;
  left: 32px;
  top: 50%;
  opacity: 0;
  transform: translateY(-50%) translateX(-100%);
  transition: transform 0.3s linear, opacity 0.3s linear;
  pointer-events: none;
}
.ids-module-nav-item.color-variant-module-nav.display-mode-expanded {
  height: var(--ids-module-nav-item-collapsed-size);
  margin-block: var(--ids-module-nav-item-collapsed-general-space-size);
  margin-inline: var(--ids-module-nav-item-margin-inline);
  padding: var(--ids-module-nav-item-padding-block);
}
.ids-module-nav-item.color-variant-module-nav.display-mode-expanded:not(.depth-1).first-child {
  margin-block-start: var(--ids-module-nav-item-collapsed-general-space-size);
}
.ids-module-nav-item.color-variant-module-nav.display-mode-expanded:not(.depth-1).last-child {
  margin-block-end: var(--ids-module-nav-item-collapsed-general-space-size);
}
.ids-module-nav-item.color-variant-module-nav.display-mode-expanded .ids-accordion-expander-icon {
  width: var(--ids-module-nav-item-dropdown-icon-size);
}
.ids-module-nav-item.color-variant-module-nav.display-mode-expanded .ids-accordion-expander-icon:last-child {
  margin-inline-end: 0;
}
.ids-module-nav-item.color-variant-sub-module-nav {
  border-color: var(--ids-color-transparent);
  border-radius: var(--ids-module-nav-common-border-radius);
  border-style: solid;
  border-width: var(--ids-border-width-sm);
  color: var(--ids-module-nav-item-text-color);
}
.ids-module-nav-item.color-variant-sub-module-nav:hover {
  background-color: var(--ids-module-nav-item-hover-bg-color);
  color: var(--ids-module-nav-item-hover-text-color);
}
.ids-module-nav-item.color-variant-sub-module-nav:active {
  background-color: var(--ids-module-nav-item-selected-bg-color);
  color: var(--ids-module-nav-item-selected-text-color);
  border-color: var(--ids-module-nav-item-active-border-color);
}
.ids-module-nav-item.color-variant-sub-module-nav:focus:not(.hide-focus) {
  border-color: var(--ids-module-nav-item-active-border-color);
}
.ids-module-nav-item.color-variant-sub-module-nav.selected {
  background-color: var(--ids-module-nav-item-selected-bg-color);
  color: var(--ids-module-nav-item-selected-text-color);
}
.ids-module-nav-item.color-variant-sub-module-nav[disabled] {
  color: var(--ids-module-nav-item-text-color);
}
.ids-module-nav-item.color-variant-sub-module-nav .filter {
  color: var(--ids-module-nav-item-text-color);
}
.ids-module-nav-item.color-variant-sub-module-nav.hidden-by-filter.child-filter-match {
  color: var(--ids-module-nav-item-text-color);
}
.ids-module-nav-item.color-variant-sub-module-nav:not([class*=display-mode-]) {
  height: var(--ids-module-nav-item-collapsed-size);
  margin-block: var(--ids-module-nav-item-collapsed-general-space-size);
  margin-inline: auto;
  overflow: hidden;
}
.ids-module-nav-item.color-variant-sub-module-nav:not([class*=display-mode-]) .ids-accordion-display-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  opacity: 0;
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.ids-module-nav-item.color-variant-sub-module-nav:not([class*=display-mode-]) .ids-accordion-expander-icon {
  display: none;
}
.ids-module-nav-item.color-variant-sub-module-nav.display-mode-collapsed {
  height: var(--ids-module-nav-item-collapsed-size);
  width: var(--ids-module-nav-item-collapsed-size);
  margin: var(--ids-module-nav-item-collapsed-general-space-size) auto;
}
.ids-module-nav-item.color-variant-sub-module-nav.display-mode-collapsed .ids-accordion-display-icon {
  margin-inline: var(--ids-module-nav-item-display-icon-collapsed-margin);
  padding: 0;
  justify-self: center;
  align-self: center;
  transition: none;
}
.ids-module-nav-item.color-variant-sub-module-nav.display-mode-collapsed .ids-accordion-expander-icon {
  display: none;
}
.ids-module-nav-item.color-variant-sub-module-nav.display-mode-collapsed.no-icon-collapsed {
  display: none;
}
.ids-module-nav-item.color-variant-sub-module-nav.display-mode-collapsed ::slotted(ids-text),
.ids-module-nav-item.color-variant-sub-module-nav.display-mode-collapsed .ids-text {
  position: absolute;
  left: 32px;
  top: 50%;
  opacity: 0;
  transform: translateY(-50%) translateX(-100%);
  transition: transform 0.3s linear, opacity 0.3s linear;
  pointer-events: none;
}
.ids-module-nav-item.color-variant-sub-module-nav.display-mode-expanded {
  height: var(--ids-module-nav-item-collapsed-size);
  margin-block: var(--ids-module-nav-item-collapsed-general-space-size);
  margin-inline: var(--ids-module-nav-item-margin-inline);
  padding: var(--ids-module-nav-item-padding-block);
}
.ids-module-nav-item.color-variant-sub-module-nav.display-mode-expanded:not(.depth-1).first-child {
  margin-block-start: var(--ids-module-nav-item-collapsed-general-space-size);
}
.ids-module-nav-item.color-variant-sub-module-nav.display-mode-expanded:not(.depth-1).last-child {
  margin-block-end: var(--ids-module-nav-item-collapsed-general-space-size);
}
.ids-module-nav-item.color-variant-sub-module-nav.display-mode-expanded .ids-accordion-expander-icon {
  width: var(--ids-module-nav-item-dropdown-icon-size);
}
.ids-module-nav-item.color-variant-sub-module-nav.display-mode-expanded .ids-accordion-expander-icon:last-child {
  margin-inline-end: 0;
}
.ids-module-nav-item .ids-accordion-display-icon {
  transition: none !important;
  will-change: auto;
}
.ids-module-nav-item .ids-accordion-expander-icon {
  width: var(--ids-module-nav-item-dropdown-icon-size);
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.ids-module-nav-item ::slotted(ids-text),
.ids-module-nav-item .ids-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ids-module-nav-item .ids-accordion-display-icon,
.ids-module-nav-item .ids-accordion-expander-icon {
  transition: padding var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-module-nav-item.display-mode-expanded.depth-1 {
  padding-inline-start: var(--ids-module-nav-item-padding-block);
}
.ids-module-nav-item.display-mode-expanded.depth-1.is-expandable {
  padding-inline-start: var(--ids-module-nav-item-padding-block);
}
.ids-module-nav-item.display-mode-expanded.depth-2 {
  padding-inline-start: 12px;
}
.ids-module-nav-item.display-mode-expanded.depth-2:not(.is-expandable) {
  padding-inline-start: 52px;
}
.ids-module-nav-item.display-mode-expanded.depth-2.is-expandable {
  padding-inline-start: 24px;
}
.ids-module-nav-item.display-mode-expanded.depth-2.siblings-can-expand:not(.is-expandable) {
  padding-inline-start: 46px;
}
.ids-module-nav-item.display-mode-expanded.depth-2.parent-has-icon {
  padding-inline-start: 20px;
}
.ids-module-nav-item.display-mode-expanded.depth-2.parent-has-icon:not(.is-expandable) {
  padding-inline-start: 42px;
}
.ids-module-nav-item.display-mode-expanded.depth-2.parent-has-icon.is-expandable {
  padding-inline-start: 32px;
}
.ids-module-nav-item.display-mode-expanded.depth-2.parent-has-icon.siblings-can-expand:not(.is-expandable) {
  padding-inline-start: 54px;
}
.ids-module-nav-item.display-mode-expanded.depth-3 {
  padding-inline-start: 24px;
}
.ids-module-nav-item.display-mode-expanded.depth-3:not(.is-expandable) {
  padding-inline-start: 68px;
}
.ids-module-nav-item.display-mode-expanded.depth-3.is-expandable {
  padding-inline-start: 40px;
}
.ids-module-nav-item.display-mode-expanded.depth-3.siblings-can-expand:not(.is-expandable) {
  padding-inline-start: 62px;
}
.ids-module-nav-item.display-mode-expanded.depth-3.parent-has-icon {
  padding-inline-start: 32px;
}
.ids-module-nav-item.display-mode-expanded.depth-3.parent-has-icon:not(.is-expandable) {
  padding-inline-start: 64px;
}
.ids-module-nav-item.display-mode-expanded.depth-3.parent-has-icon.is-expandable {
  padding-inline-start: 48px;
}
.ids-module-nav-item.display-mode-expanded.depth-3.parent-has-icon.siblings-can-expand:not(.is-expandable) {
  padding-inline-start: 70px;
}
.ids-module-nav-item.display-mode-expanded.depth-4 {
  padding-inline-start: 36px;
}
.ids-module-nav-item.display-mode-expanded.depth-4:not(.is-expandable) {
  padding-inline-start: 84px;
}
.ids-module-nav-item.display-mode-expanded.depth-4.is-expandable {
  padding-inline-start: 56px;
}
.ids-module-nav-item.display-mode-expanded.depth-4.siblings-can-expand:not(.is-expandable) {
  padding-inline-start: 78px;
}
.ids-module-nav-item.display-mode-expanded.depth-4.parent-has-icon {
  padding-inline-start: 44px;
}
.ids-module-nav-item.display-mode-expanded.depth-4.parent-has-icon:not(.is-expandable) {
  padding-inline-start: 80px;
}
.ids-module-nav-item.display-mode-expanded.depth-4.parent-has-icon.is-expandable {
  padding-inline-start: 64px;
}
.ids-module-nav-item.display-mode-expanded.depth-4.parent-has-icon.siblings-can-expand:not(.is-expandable) {
  padding-inline-start: 86px;
}
.ids-module-nav-item.display-mode-expanded.depth-5 {
  padding-inline-start: 48px;
}
.ids-module-nav-item.display-mode-expanded.depth-5:not(.is-expandable) {
  padding-inline-start: 100px;
}
.ids-module-nav-item.display-mode-expanded.depth-5.is-expandable {
  padding-inline-start: 72px;
}
.ids-module-nav-item.display-mode-expanded.depth-5.siblings-can-expand:not(.is-expandable) {
  padding-inline-start: 94px;
}
.ids-module-nav-item.display-mode-expanded.depth-5.parent-has-icon {
  padding-inline-start: 56px;
}
.ids-module-nav-item.display-mode-expanded.depth-5.parent-has-icon:not(.is-expandable) {
  padding-inline-start: 96px;
}
.ids-module-nav-item.display-mode-expanded.depth-5.parent-has-icon.is-expandable {
  padding-inline-start: 80px;
}
.ids-module-nav-item.display-mode-expanded.depth-5.parent-has-icon.siblings-can-expand:not(.is-expandable) {
  padding-inline-start: 102px;
}
.ids-module-nav-item.display-mode-expanded.depth-6 {
  padding-inline-start: 60px;
}
.ids-module-nav-item.display-mode-expanded.depth-6:not(.is-expandable) {
  padding-inline-start: 116px;
}
.ids-module-nav-item.display-mode-expanded.depth-6.is-expandable {
  padding-inline-start: 88px;
}
.ids-module-nav-item.display-mode-expanded.depth-6.siblings-can-expand:not(.is-expandable) {
  padding-inline-start: 110px;
}
.ids-module-nav-item.display-mode-expanded.depth-6.parent-has-icon {
  padding-inline-start: 68px;
}
.ids-module-nav-item.display-mode-expanded.depth-6.parent-has-icon:not(.is-expandable) {
  padding-inline-start: 112px;
}
.ids-module-nav-item.display-mode-expanded.depth-6.parent-has-icon.is-expandable {
  padding-inline-start: 96px;
}
.ids-module-nav-item.display-mode-expanded.depth-6.parent-has-icon.siblings-can-expand:not(.is-expandable) {
  padding-inline-start: 118px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
